/**
 * Create store system routing-secuiRip
 *
 * @since 2018-07-09
 * @author jongsung.Lee(devp010)
 */

import {SystemApiPrefix as smApiPrefix} from 'utils'
import compareObject from '~/utils/compare'

export const plugins = [Plugin]

export const state = () => ({
  // axios api's urls
  apiUrlPath: {
    // rip config
    secuiRipConfig: `${smApiPrefix}/ipv6/secui-rip/config`,
    // interface candidates
    secuiIfsCandidates: `${smApiPrefix}/ipv6/secui-rip/config/interface-candidates`,
    // ha interface candidates
    secuiHaIfsCandidates: `${smApiPrefix}/ipv6/secui-rip/config/ha-interface-candidates`,
    // ha ip candidates
    secuiHaIpCandidates: `${smApiPrefix}/ipv6/secui-rip/config/{id}/ha-ip-candidates`,
    // rip has
    secuiRipHas: `${smApiPrefix}/ipv6/secui-rip/config/has`,
    // rip apply
    secuiRipApply: `${smApiPrefix}/ipv6/secui-rip/config/apply`,
    // rip cancel
    secuiRipCancel: `${smApiPrefix}/ipv6/secui-rip/config/cancel`
  },
  // copyData for editing.
  selectedItem: {},
  // config
  secuiRipVersion: [{label: '1', value: 1}, {label: '2', value: 2}],
  secuiRipMethod: [{label: 'Broadcast', value: 1}, {label: 'Multicast', value: 2}],
  secuiRipConfig: {
    active: 0, //         (OFF: 0, SECUI_RIP: 1, SECUI_ML_RIP: 2)
    trans_interval: 10, // (unit: sec)
    expired: 30, //       (unit: sec)
    ifc_id: '', //        SECUI_ML_RIP
    ifc_name: '', //      SECUI_ML_RIP
    vpn_ha_members: 1 //  SECUI_RIP - (integer - minimum: 1 - maximum: 7)
  },
  secuiRipConfigClone: {
    active: 0,
    trans_interval: 10,
    expired: 30,
    ifc_id: 0,
    ifc_name: '',
    vpn_ha_members: 1
  },
  secuiRipIfsCandisList: [], //   id, name
  secuiRipHaIfsCandisList: [], // id, name
  secuiRipHaIpsCandisList: [], //  id, ip
  secuiRipHas: { // has
    id: 0,
    ifc_id: '',
    ifc_name: '',
    ip_id: '',
    ip_addr: '',
    rout_addr: null,
    rout_mask: 0, //    daeyong09.kim : Ipv4's mask(0~32)
    ha_priority: 1, //  (integer - minimum: 1 - maximum: 7)
    metric: 1, //       (integer - minimum: 1 - maximum: 16)
    vpn_sa_enable: 0 // (OFF: 0, ON: 1)
  },
  secuiRipHasList: []
})

export const mutations = {
  resetSelectedItem (state) {
    state.selectedItem = {}
  },
  setSelectedItem (state, item) {
    state.selectedItem = item
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> config
  resetSecuiRipConfig (state) {
    state.secuiRipConfig.active = 0
    state.secuiRipConfig.trans_interval = 10
    state.secuiRipConfig.expired = 30
    state.secuiRipConfig.ifc_id = ''
    state.secuiRipConfig.ifc_name = ''
    state.secuiRipConfig.vpn_ha_members = 1
  },
  setSecuiRipConfig (state, item) {
    state.secuiRipConfig.active = item.active
    state.secuiRipConfig.trans_interval = item.trans_interval
    state.secuiRipConfig.expired = item.expired
    state.secuiRipConfig.ifc_id = item.ifc_id
    state.secuiRipConfig.ifc_name = item.ifc_name
    state.secuiRipConfig.vpn_ha_members = item.vpn_ha_members
    // clone
    state.secuiRipConfigClone.active = _.cloneDeep(item.active)
    state.secuiRipConfigClone.trans_interval = _.cloneDeep(item.trans_interval)
    state.secuiRipConfigClone.expired = _.cloneDeep(item.expired)
    state.secuiRipConfigClone.ifc_id = _.cloneDeep(item.ifc_id)
    state.secuiRipConfigClone.ifc_name = _.cloneDeep(item.ifc_name)
    state.secuiRipConfigClone.vpn_ha_members = _.cloneDeep(item.vpn_ha_members)
  },
  resetSecuiRipConfigIfs (state) {
    state.secuiRipIfsCandisList = []
  },
  setSecuiRipConfigIfs (state, data) {
    if (data !== undefined) {
      for (const ifs of data) {
        state.secuiRipIfsCandisList.push(
          {
            label: ifs.name,
            value: ifs.id
          }
        )
      }
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ha
  clearSecuiRipHas (state) {
    state.secuiRipHas.id = 0
    state.secuiRipHas.ifc_id = ''
    state.secuiRipHas.ifc_name = ''
    state.secuiRipHas.ip_id = ''
    state.secuiRipHas.ip_addr = ''
    state.secuiRipHas.rout_addr = null
    state.secuiRipHas.rout_mask = 0
    state.secuiRipHas.ha_priority = 1
    state.secuiRipHas.metric = 1
    state.secuiRipHas.vpn_sa_enable = 0
  },
  setSecuiRipHas (state, item) {
    state.secuiRipHas.id = item.id
    state.secuiRipHas.ifc_id = item.ifc_id
    state.secuiRipHas.ifc_name = item.ifc_name
    state.secuiRipHas.ip_id = item.ip_id
    state.secuiRipHas.ip_addr = item.ip_addr
    state.secuiRipHas.rout_addr = item.rout_addr
    state.secuiRipHas.rout_mask = item.rout_mask
    state.secuiRipHas.ha_priority = item.ha_priority
    state.secuiRipHas.metric = item.metric
    state.secuiRipHas.vpn_sa_enable = item.vpn_sa_enable
  },
  resetSecuiRipHaList (state) {
    state.secuiRipHasList = []
  },
  setSecuiRipHaList (state, data) {
    state.secuiRipHasList = data
  },
  resetSecuiRipHaIfs (state) {
    state.secuiRipHaIfsCandisList = []
  },
  setSecuiRipHaIfs (state, data) {
    if (data !== undefined) {
      for (const ifs of data) {
        state.secuiRipHaIfsCandisList.push(
          {
            label: ifs.name,
            value: ifs.id
          }
        )
      }
    }
  },
  resetSecuiRipHaIps (state) {
    state.secuiRipHaIpsCandisList = []
  },
  setSecuiRipHaIps (state, data) {
    if (data !== undefined && data.length > 0) {
      for (const ips of data) {
        state.secuiRipHaIpsCandisList.push(
          {
            label: ips.ip,
            value: ips.id
          }
        )
      }
    } else {
      state.secuiRipHaIpsCandisList = []
    }
  },
  addSecuiRipHaList (state, item) {
    if (item !== undefined) {
      state.secuiRipHasList.push(item)
    }
  },
  editSecuiRipHaList (state, item) {
    const findRslt = _.find(state.secuiRipHasList, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.secuiRipHasList.splice(_.findIndex(state.secuiRipHasList, state.selectedItem), 1, item)
    }
  },
  delSecuiRipHaList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.secuiRipHasList.splice(item.itemIndex, 1)
      }
    }
  }
}

export const actions = {
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> config
  async getSecuiRipConfig ({commit, state}, loadingOpt) {
    commit('resetSecuiRipConfig')
    const apiUrl = state.apiUrlPath['secuiRipConfig']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setSecuiRipConfig', result)
      return true
    } else {
      return false
    }
  },
  async editSecuiRipConfig ({commit, state}, loadingOpt) {
    const apiUrl = state.apiUrlPath['secuiRipConfig']
    const rslt = await this.$axios.$put(apiUrl, state.secuiRipConfig, loadingOpt)
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('setSecuiRipConfig', rslt.result)
      return true
    } else {
      return false
    }
  },
  async getSecuiRipConfigIfsCandidates ({commit, state}, loadingOpt) {
    commit('resetSecuiRipConfigIfs')
    const apiUrl = state.apiUrlPath['secuiIfsCandidates']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setSecuiRipConfigIfs', result)
      return true
    } else {
      return false
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ha
  async getSecuiRipHaList ({commit, state}) {
    commit('resetSecuiRipHaList')
    const apiUrl = state.apiUrlPath['secuiRipHas']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setSecuiRipHaList', result)
      return true
    } else {
      return false
    }
  },
  async getSecuiRipHaIfsCandidates ({commit, state}, loadingOpt) {
    commit('resetSecuiRipHaIfs')
    const apiUrl = state.apiUrlPath['secuiHaIfsCandidates']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setSecuiRipHaIfs', result)
      return true
    } else {
      return false
    }
  },
  async getSecuiRipHaIpsCandidates ({commit, state}, ifcId) {
    commit('resetSecuiRipHaIps')
    const apiUrl = state.apiUrlPath['secuiHaIpCandidates'].replace('{id}', ifcId)
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setSecuiRipHaIps', result)
      return true
    } else {
      return false
    }
  },
  async addSecuiRipHaList ({commit, state}) {
    const apiUrl = state.apiUrlPath['secuiRipHas']
    const addParam = _.cloneDeep(state.secuiRipHas)
    addParam.rout_mask = Number(addParam.rout_mask)
    delete addParam.id
    // route_mask type : string
    const {code, result} = await this.$axios.$post(apiUrl, addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addSecuiRipHaList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async editSecuiRipHaList ({commit, state}) {
    const apiUrl = state.apiUrlPath['secuiRipHas']
    const putParam = _.cloneDeep(state.secuiRipHas)
    putParam.rout_mask = Number(putParam.rout_mask)
    const {code, result} = await this.$axios.$put(`${apiUrl}/${state.secuiRipHas.id}`, putParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('editSecuiRipHaList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async delSecuiRipHaList ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({id: idx.id, pokName: idx.pokName})
    }
    const apiUrl = state.apiUrlPath['secuiRipHas']
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].id}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delSecuiRipHaList', param.itemIndexList)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> apply & cancel
  async setSecuiRipApply ({commit, state}, loadingOpt) {
    const data = await this.$axios.$put(state.apiUrlPath['secuiRipApply'], null, loadingOpt)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      return false
    }
  },
  async setSecuiRipCancel ({commit, state}, loadingOpt) {
    const data = await this.$axios.$put(state.apiUrlPath['secuiRipCancel'], null, loadingOpt)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      return false
    }
  }
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< Bgp apply & cancel
}

export const getters = {
  // secuiRip Config
  compareSecuiRipConfigData (state) {
    return compareObject(state.secuiRipConfig, state.secuiRipConfigClone)
  }
}

export const strict = false
